import {hitType} from "../../analytics.helper";
import {zoomIntegrationActionTypes} from "../../../../_constants/actions/integrations/zoomIntegrationActiontypes";

// UTILITY-HELPERS ##########################################################

// generic zoom event
const genericZoomEvent = (event, values = {}) => {
	return {
		event: event,
		hitType: hitType.EVENT,
		values: values,
	};
};

// EVENTS ##########################################################

// expand zoom meeting instance
const expandZoomMeeting = () => genericZoomEvent(zoomIntegrationActionTypes.ZOOM_MEETING_EXPAND);

// collapse zoom meeting instance
const collapseZoomMeeting = () => genericZoomEvent(zoomIntegrationActionTypes.ZOOM_MEETING_COLLAPSE);

// preview of (original) zoom meeting recording
const previewZoomMeetingRecording = () => genericZoomEvent(zoomIntegrationActionTypes.ZOOM_MEETING_RECORDING_PREVIEW);

// zoom connect success
const zoomConnectSuccess = () => genericZoomEvent(zoomIntegrationActionTypes.CONNECT_ZOOM_INTEGRATION_SUCCESS);

// zoom disconnect success
const zoomDisconnectSuccess = () => genericZoomEvent(zoomIntegrationActionTypes.DISCONNECT_ZOOM_INTEGRATION_SUCCESS);


// EVENT-MAPPINGS ##########################################################

// zoom events mappings
export const zoomEventsMap = {
	[zoomIntegrationActionTypes.ZOOM_MEETING_EXPAND]                : expandZoomMeeting,
	[zoomIntegrationActionTypes.ZOOM_MEETING_COLLAPSE]              : collapseZoomMeeting,
	[zoomIntegrationActionTypes.ZOOM_MEETING_RECORDING_PREVIEW]     : previewZoomMeetingRecording,
	[zoomIntegrationActionTypes.CONNECT_ZOOM_INTEGRATION_SUCCESS]   : zoomConnectSuccess,
	[zoomIntegrationActionTypes.DISCONNECT_ZOOM_INTEGRATION_SUCCESS]: zoomDisconnectSuccess,
};